<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px; display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; gap: 10px; align-items: center;">
          <label>搜索：</label>
          <a-input-search
            v-model="filter.keywords"
            placeholder="搜索兑换码"
            style="width: 200px"
            @search="searchData"
            class="mr10px"
          />
          <label>状态：</label>
          <a-select v-model="filter.status" style="width: 120px" placeholder="全部状态" @change="searchData" allowClear>
            <a-select-option :value="0">未使用</a-select-option>
            <a-select-option :value="1">已使用</a-select-option>
          </a-select>
        </div>
        <div>
          <a-button type="primary" @click="showCreateModal">批量生成兑换码</a-button>
        </div>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="changePage"
      >
        <template slot="bag_name" slot-scope="text, record">
          <a href="javascript:;" @click="showDetail(record)" style="max-width: 180px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle;" :title="text">
            {{ text || '-' }}
          </a>
        </template>
        <template slot="status" slot-scope="text">
          <a-badge :status="text === 1 ? 'success' : 'default'" :text="text === 1 ? '已使用' : '未使用'" />
        </template>
        <template slot="use_time" slot-scope="text">
          <span>{{ text > 0 ? formatDate(text * 1000) : '-' }}</span>
        </template>
        <template slot="create_time" slot-scope="text">
          <span>{{ formatDate(text * 1000) }}</span>
        </template>
        <template slot="use_nickname" slot-scope="text, record">
          <span>{{ text ? `${text} (ID: ${record.use_uid})` : '-' }}</span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm
            v-if="record.status === 0"
            title="确定要删除这个未使用的兑换码吗？"
            ok-text="确认"
            cancel-text="取消"
            @confirm="deleteItem(record.id)"
          >
            <a href="javascript:;" style="color: red;">删除</a>
          </a-popconfirm>
          <span v-else style="color: #ccc; cursor: not-allowed;">删除</span>
        </template>
      </a-table>
    </div>

    <!-- 批量生成兑换码弹窗 -->
    <a-modal
      title="批量生成兑换码"
      :visible="createVisible"
      :confirm-loading="createLoading"
      @ok="handleCreate"
      @cancel="createVisible = false"
      okText="生成"
      cancelText="取消"
      width="600px"
    >
      <a-form-model :model="form" ref="redeemForm" :rules="rules" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
        <a-form-model-item label="绑定内容" required>
          <div style="margin-bottom: 8px; display: flex; gap: 8px;">
            <a-button size="small" @click="expandAll(true)">全部展开</a-button>
            <a-button size="small" @click="expandAll(false)">全部折叠</a-button>
            <a-button size="small" type="danger" ghost @click="checkedKeys = []">清空勾选</a-button>
          </div>
          <div style="border: 1px solid #d9d9d9; border-radius: 4px; padding: 12px; max-height: 320px; overflow-y: auto; background-color: #fafafa;">
            <a-tree
              checkable
              :tree-data="treeData"
              v-model="checkedKeys"
              :expanded-keys="expandedKeys"
              @expand="onExpand"
            />
          </div>
          <div style="margin-top: 4px; font-size: 12px; color: #888;">
            * 勾选【套卷】将自动兑换其下的所有单卷；也可以展开后仅勾选部分【单卷】进行精准兑换。
          </div>
        </a-form-model-item>
        <a-form-model-item label="生成数量" prop="count">
          <a-input-number v-model="form.count" :min="1" :max="1000" style="width: 100%" placeholder="请输入生成数量" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 关联详情弹窗 -->
    <a-modal
      title="关联试卷详情"
      :visible="detailVisible"
      @ok="detailVisible = false"
      @cancel="detailVisible = false"
      :footer="null"
      destroyOnClose
      width="500px"
    >
      <a-list size="small" bordered :data-source="detailList">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-tag :color="item.type === 'bag' ? 'blue' : 'green'">
            {{ item.type === 'bag' ? '套卷' : '单卷' }}
          </a-tag>
          <span style="font-weight: 500;">{{ item.name }}</span>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import * as http from '@/libs/examapi'
import { formatDate } from '@/libs/moment'

const columns = [
  {
    title: '兑换码',
    dataIndex: 'code',
    align: 'center'
  },
  {
    title: '关联套卷',
    dataIndex: 'bag_name',
    scopedSlots: { customRender: 'bag_name' },
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center'
  },
  {
    title: '使用者',
    dataIndex: 'use_nickname',
    scopedSlots: { customRender: 'use_nickname' },
    align: 'center'
  },
  {
    title: '使用时间',
    dataIndex: 'use_time',
    scopedSlots: { customRender: 'use_time' },
    align: 'center'
  },
  {
    title: '生成时间',
    dataIndex: 'create_time',
    scopedSlots: { customRender: 'create_time' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
]

export default {
  name: 'redeemCodeList',
  data () {
    return {
      columns,
      data: [],
      loading: false,
      filter: {
        keywords: '',
        status: undefined
      },
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      createVisible: false,
      createLoading: false,
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      form: {
        count: 5
      },
      rules: {
        count: [{ required: true, message: '请输入生成数量', trigger: 'blur' }]
      },
      detailVisible: false,
      detailList: [],
      bagMap: {},
      paperMap: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    formatDate,
    getData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keywords: this.filter.keywords,
        status: this.filter.status
      }
      http.getRedeemCodes(params).then(res => {
        this.data = res.data
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
        this.$message.error('获取兑换码列表失败')
      })
    },
    getTreeData () {
      this.loading = true
      http.get_crouse_list({ page: 1, pageSize: 1000, detail_type: 1 }).then(res1 => {
        const bags = res1.data || []
        
        const bagMap = {}
        bags.forEach(bag => {
          bagMap[bag.id] = bag.title
        })
        this.bagMap = bagMap

        const promises = bags.map(bag => {
          return http.getGoodTask({ cate_id: bag.id }).then(res2 => {
            const papers = res2 || []
            const children = papers.map(p => ({
              title: `【单卷】${p.name}`,
              key: `paper_${p.id}`,
              isLeaf: true
            }))
            return {
              title: `【套卷】${bag.title} (${children.length}张卷)`,
              key: `bag_${bag.id}`,
              children: children,
              rawPapers: papers
            }
          }).catch(err => {
            console.error(`获取套卷 ${bag.title} 的单卷失败:`, err)
            return {
              title: `【套卷】${bag.title} (获取单卷失败)`,
              key: `bag_${bag.id}`,
              children: [],
              rawPapers: []
            }
          })
        })

        Promise.all(promises).then(results => {
          this.treeData = results
          
          const paperMap = {}
          results.forEach(res => {
            if (res.rawPapers) {
              res.rawPapers.forEach(p => {
                paperMap[p.id] = p.name
              })
            }
          })
          this.paperMap = paperMap
          
          this.loading = false
        })
      }).catch(err => {
        console.error(err)
        this.loading = false
        this.$message.error('加载套卷及试卷数据失败')
      })
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    expandAll (expand) {
      if (expand) {
        this.expandedKeys = this.treeData.map(item => item.key)
      } else {
        this.expandedKeys = []
      }
    },
    searchData () {
      const pagination = { ...this.pagination }
      pagination.current = 1
      this.pagination = pagination
      this.getData()
    },
    changePage (pagination) {
      const pag = { ...this.pagination }
      pag.current = pagination.current
      this.pagination = pag
      this.getData()
    },
    showCreateModal () {
      this.checkedKeys = []
      this.expandedKeys = []
      this.form.count = 5
      this.createVisible = true
      this.getTreeData()
      this.$nextTick(() => {
        if (this.$refs.redeemForm) {
          this.$refs.redeemForm.resetFields()
        }
      })
    },
    handleCreate () {
      if (this.checkedKeys.length === 0) {
        this.$message.warning('请勾选要绑定的套卷或试卷！')
        return
      }
      this.$refs.redeemForm.validate(valid => {
        if (valid) {
          const bags = []
          const papers = []

          // 区分勾选的是整套还是单张试卷
          this.treeData.forEach(node => {
            if (this.checkedKeys.includes(node.key)) {
              bags.push(parseInt(node.key.replace('bag_', '')))
            } else {
              node.children.forEach(child => {
                if (this.checkedKeys.includes(child.key)) {
                  papers.push(parseInt(child.key.replace('paper_', '')))
                }
              })
            }
          })

          this.createLoading = true
          const params = {
            relation_data: { bags, papers },
            count: this.form.count
          }
          http.createRedeemCodes(params).then(res => {
            this.createLoading = false
            this.$message.success('兑换码生成成功')
            this.createVisible = false
            this.searchData()
          }).catch(err => {
            console.error(err)
            this.createLoading = false
            this.$message.error('生成失败')
          })
        }
      })
    },
    deleteItem (id) {
      http.delRedeemCode({ id }).then(res => {
        this.$message.success('删除成功')
        this.getData()
      }).catch(err => {
        console.error(err)
        this.$message.error('删除失败')
      })
    },
    showDetail (record) {
      const list = []
      let parsed = null
      
      if (record.relation_data) {
        try {
          parsed = JSON.parse(record.relation_data)
        } catch (e) {
          console.error('解析 relation_data 失败', e)
        }
      }

      if (parsed) {
        if (parsed.bags && parsed.bags.length > 0) {
          parsed.bags.forEach(bId => {
            const title = this.bagMap[bId] || `套卷 (ID: ${bId})`
            list.push({ type: 'bag', name: title })
          })
        }
        if (parsed.papers && parsed.papers.length > 0) {
          parsed.papers.forEach(pId => {
            const name = this.paperMap[pId] || `单卷 (ID: ${pId})`
            list.push({ type: 'paper', name: name })
          })
        }
      }

      if (list.length === 0 && record.bag_name) {
        // 兼容降级
        list.push({ type: 'bag', name: record.bag_name })
      }

      this.detailList = list
      this.detailVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
